import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    withRouter,
    useParams
} from 'react-router-dom';

import './Project.css'
import firebase from '../../services/Firebase'
import Modal from 'react-responsive-modal';
import "react-responsive-modal/styles.css";




function useProject() {

    const [project, setProject] = React.useState([]);
    const { id } = useParams();

    React.useEffect(() => {
        firebase.firestore().collection('projects').doc(id).onSnapshot(snapshot => {
            setProject(snapshot.data())

        })
    }, []);

    return project;

}

function useProposals() {
    
    const [proposals, setProposals] = React.useState([]);
    const { id } = useParams();

    React.useEffect(() => {
        firebase.firestore().collection('proposals').where("project", "==", id)
            .onSnapshot((snapshot) => {
                const newProposals = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setProposals(newProposals)
            })
    }, []);

    return proposals;
}


function useComments() {
    
    const [comments, setComments] = React.useState([]);
    const { id } = useParams();

    React.useEffect(() => {
        firebase.firestore().collection('comments')
        .where("project", "==", id)
           
            .onSnapshot((snapshot) => {
                const newComments = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setComments(newComments)
            })
    }, []);

    return comments;
}



function Project(props) {

    const project = useProject();
    const proposals = useProposals();
    const comments = useComments();
    const { id } = useParams();

    const [comment, setComment] = React.useState("");

    const [openCreateProposal, setOpenCreateProposal] = React.useState(false);

    const [proposal, setProposal] = React.useState(
        {
            caption: "",
            name: "",
            assets: [],
            description: "",
            members: [{name: "Tin Sohn", role: "Project Owner", imgurl: "https://www.xing.com/image/8_8_5_4e8c52173_23470511_1/tin-stribor-sohn-foto.1024x1024.jpg"}],
            timestamp: Date.now(),
            project: id
        }
    )

    const handleProposalChange = event => {
        setProposal({...proposal,[event.target.name]: event.target.value})
    }


    const handleCommentChange = event => {
        setComment(event.target.value);
    }

    const addProposal = event => {
        firebase.firestore().collection('proposals').add(proposal)
    }

    const addComment = event => {
        firebase.firestore().collection('comments').add({
            sender: {name: "Tin", img: "https://www.xing.com/image/8_8_5_4e8c52173_23470511_1/tin-stribor-sohn-foto.1024x1024.jpg"},
            message: comment,
            timestamp: Date.now(),
            project: id
        })
    }


    const handleCreateProposalModalOpen = event => {
        setOpenCreateProposal(true)
    }

    const handleCreateProposalModalClose = event => {
        setOpenCreateProposal(false)
    }
    

    return (
        <>
            <div className="project-main-container">


                <div className="project-main-img-container">
                    <img className="project-main-img" src={project.imgurl}></img>
                    <div className="project-main-description-container">
                        <h1>{project.name}</h1>
                        <p>Ansprechpartner<b> {project.owner && project.owner.name}</b></p>
                        <p>{project.caption}</p>
                    </div>
                </div>


                <div className="project-main-proposals-container">
                    <h1>
                        Über uns
                    </h1>
                    <p className="about">{project.about}</p>
                </div>



                <div className="project-main-proposals-container">
                    <h1>
                        Wie sind wir von der Corona Krise betroffen?
                    </h1>
                    <p className="about">{project.story}</p>
                </div>

                <div className="project-main-proposals-container">
                    <h1>
                        Was brauchen wir?
                    </h1>
                    <p className="about">{project.need}</p>
                </div>

                <div className="project-main-proposals-container">
                    <h1>
                        Projektvorschläge
                      
                    </h1>
                    <button onClick={handleCreateProposalModalOpen} className="projects-add-button" >+ Neuen Projektvorschlag erstellen</button>

                    <Modal open={openCreateProposal} onClose={handleCreateProposalModalClose}>

                        <div className="modal">
                        <h1>Neuen Projektvorschlag erstellen</h1>

                        <h4>Projektname</h4>
                        <textarea name="name" onChange={handleProposalChange} rows="1" placeholder="Name für das Projekt..." ></textarea>
                        <h4>Kurzbeschreibung</h4>
                        <textarea name="caption"  onChange={handleProposalChange}  rows="1" placeholder="Beschreibe das Projekt in einem Satz" ></textarea>

                        <h4>Story</h4>
                        <textarea name="description"  onChange={handleProposalChange}  rows="4"></textarea>


                        <h4>Assets</h4>
                        <h5>Cloud Ordner</h5>
                        <textarea rows="1" placeholder="cloud ordner" ></textarea>
                        <h5>Slack</h5>
                        <textarea rows="1" placeholder="slack" ></textarea>
                        <h5>Trello</h5>
                        <textarea rows="1" placeholder="trello board" ></textarea>
                        <h5>Github</h5>
                        <textarea rows="1" placeholder="github link" ></textarea>

                        <br></br><br></br>
                        <button onClick={addProposal} className="projects-enter-button">Projektvorschlag einreichen</button>
                        </div>

                    </Modal>

                    {proposals.map (proposal => <div className="proposals-item" key={proposal.id}>
                        <div><h2>{proposal.name}</h2><span>{proposal.caption}</span></div>
                        <div className="members-container"><Link to={"/proposal/"+proposal.id}><button className="projects-enter-button">Mehr erfahren</button></Link><br></br><span>{proposal.members.length} Teammitglieder</span></div>
                    </div>)}
       
                </div>

                <div className="project-main-proposals-container">
                    <h1>
                        Kommentare
                    </h1>


                    <div><input type="text" value={comment} placeholder="ein Kommentar schreiben..." onChange={handleCommentChange} className="comment-input"></input><button onClick={addComment} className="projects-button" >Kommentieren</button></div>
                    
                    
                    {comments.map(comment=> <div className="comment-item">
                    <img className="comment-profile-picture" src={comment.sender.img}></img> <p>{comment.sender.name}</p>
                        <p>{comment.message}
                        </p>
                      

                    </div>)}





                </div>



            </div>
        </>
    )
}

export default withRouter(Project);